export const FILTER_ACTIONS = {
  RESET_ALL_FILTERS: "resetAllFilters",
  SET_FILTER_BY_MENS_CATEGORY: "setFilterByMensCategory",
  SET_FILTER_BY_WOMENS_CATEGORY: "setFilterByWomensCategory",
  SET_FILTER_BY_KIDS_CATEGORY: "setFilterByKidsCategory",
  SET_FILTER_BY_OTHERS_CATEGORY: "setFilterByOthersCategory",
  SET_FILTER_BY_EXCLUDE_OUT_OF_STOCK: "setFilterByExcludeOutOfStock",
  SET_FILTER_BY_EXCLUDE_NORMAL_DELIVERY: "setFilterByExcludeNormalDelivery",
  SET_FILTER_BY_MAX_PRICE: "setFilterByMaxPrice",
  SET_FILTER_BY_RATING: "setFilterByRating",
  SET_SORT_BY_PRICE_FROM_LOW_TO_HIGH: "setSortByPriceFromLowToHigh",
  SET_SORT_BY_PRICE_FROM_HIGH_TO_LOW: "setSortByPriceFromHighToLow",
};
